
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandV as ObiOwnShipNoCommandVElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-v.js';
 
 
 

 
 export const ObiOwnShipNoCommandV = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-v',
   elementClass: ObiOwnShipNoCommandVElement,
   events: {
     
   }
  });
 
 